import styled from 'styled-components';
import { Link } from 'gatsby';
export const Wrapper = styled.section`
  display: flex;
  justify-content: ${({ justify }) => justify};
  & > *:not(first-child) {
    margin-left: 0.5rem;
  }
`;

export const RelativePostItem = styled(Link)`
  padding: 0.4rem 1rem;
  border: 1px solid var(--green-1);
  border-radius: 0.2rem;
  transition: var(--mainTransition);
  cursor: pointer;
  max-width: 46%;
  svg {
    font-size: 1.5rem;
  }
  &:hover {
    color: white;
    background-color: var(--green-1);
    transform: translateY(-3px);
  }
`;
